import { z } from 'zod';

export const changeUnexpectedPaymentOutcomeGetResponseSchema = z.object({
  data: z.object({
    settings: z.array(z.object({ display_name: z.string().optional(), setting: z.string().optional() })).optional(),
  }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
